module.exports = __webpack_public_path__ + "static/media/branding-first@3x.76d1ac1c.jpg";